import { createAsyncThunk } from "@reduxjs/toolkit";
import companiesApi from "../../../../configs/apis/companies";

export const getCompanies = createAsyncThunk(
  "companies/getCompanies",
  async (payload, { rejectWithValue }) =>
    companiesApi
      .getListing({
        page: payload.page,
        length: payload.length,
        companyName: payload.companyName,
        regNo: payload.regNo,
        plan: payload.plan,
        status: payload.status,
        expiredSort: payload.expiredSort,
      })
      .then((response) => response.data)
      .catch((error) => rejectWithValue(error))
);

export const putWhiteLabel = createAsyncThunk(
  "companies/putWhiteLabel",
  async (payload, { rejectWithValue }) =>
    companiesApi
      .putWhiteLabel({ id: payload.id, whiteLabel: payload.whiteLabel })
      .then((response) => response.data)
      .catch((error) => rejectWithValue(error))
);

export const removeCompanyWhiteLabel = createAsyncThunk(
  "companies/removeCompanyWhiteLabel",
  async (payload, { rejectWithValue }) =>
    companiesApi
      .removeCompanyWhiteLabel({ id: payload.id })
      .then((response) => response.data)
      .catch((error) => rejectWithValue(error))
);

export const getAccessRights = createAsyncThunk(
  "companies/getAccessRights",
  async (payload, { rejectWithValue }) =>
    companiesApi
      .getAccessRights(payload)
      .then((response) => response.data)
      .catch((error) => rejectWithValue(error))
);

export const updateAccessRights = createAsyncThunk(
  "companies/updateAccessRights",
  async (payload, { rejectWithValue }) =>
    companiesApi
      .updateAccessRights(payload)
      .then((response) => response.data)
      .catch((error) => rejectWithValue(error))
);

export const getCompanyPlanInfo = createAsyncThunk(
  "companies/getCompanyPlanInfo",
  async (payload, { rejectWithValue }) =>
    companiesApi
      .getCompanyPlanInfo(payload)
      .then((response) => response.data)
      .catch((error) => rejectWithValue(error))
);

export const updateCompanyPlan = createAsyncThunk(
  "companies/updateCompanyPlan",
  async (payload, { rejectWithValue }) =>
    companiesApi
      .updateCompanyPlan(payload)
      .then((response) => response.data)
      .catch((error) => rejectWithValue(error))
);

export const getNodesWithWhiteLabel = createAsyncThunk(
  "companies/getNodesWithWhiteLabel",
  async (payload, { rejectWithValue }) =>
    companiesApi
      .getNodesWithWhiteLabel(payload)
      .then((response) => response.data)
      .catch((error) => rejectWithValue(error))
);

export const putBranchWhiteLabel = createAsyncThunk(
  "companies/putBranchWhiteLabel",
  async (payload, { rejectWithValue }) =>
    companiesApi
      .putBranchWhiteLabel({ id: payload.id, whiteLabel: payload.whiteLabel })
      .then((response) => response.data)
      .catch((error) => rejectWithValue(error))
);

export const removeBranchWhiteLabel = createAsyncThunk(
  "companies/removeBranchWhiteLabel",
  async (payload, { rejectWithValue }) =>
    companiesApi
      .removeBranchWhiteLabel({ id: payload.id })
      .then((response) => response.data)
      .catch((error) => rejectWithValue(error))
);

export const getBranchListByProduct = createAsyncThunk(
  "companies/getBranchList",
  async (payload, { rejectWithValue }) =>
    companiesApi
      .getBranchListByProduct({ payload })
      .then((response) => response.data)
      .catch((error) => rejectWithValue(error))
);

export const getProductList = createAsyncThunk(
  "companies/getProductList",
  async (payload, { rejectWithValue }) =>
    companiesApi
      .getProductList({ payload })
      .then((response) => response.data)
      .catch((error) => rejectWithValue(error))
);

export const updateAssign = createAsyncThunk(
  "companies/updateAssign",
  async (payload, { rejectWithValue }) =>
    companiesApi
      .updateAssign({ payload })
      .then((response) => response.data)
      .catch((error) =>
        rejectWithValue({
          message: error.message,
          code: error.code,
          data: error.data,
        })
      )
);

export const updateUnassignUrl = createAsyncThunk(
  "companies/updateUnassignUrl",
  async (payload, { rejectWithValue }) =>
    companiesApi
      .updateUnassignUrl({ payload })
      .then((response) => response.data)
      .catch((error) =>
        rejectWithValue({
        message: error.message,
        code: error.code,
        data: error.data,
        })
      )
);

export const validateUnassignUrl = createAsyncThunk(
  "companies/validateUnassignUrl",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await companiesApi.validateUnassignUrl({ payload });
      return response;
    } catch (error) {
      return rejectWithValue({
        message: error.message,
        code: error.code,
        data: error.data,
      });
    }
  }
);

export const validateUnassignRange = createAsyncThunk(
  "companies/validateUnassignRange",
  async (payload, { rejectWithValue }) =>
    companiesApi
      .validateUnassignRange({
        payload: {
          node_id: payload.node_id,
          type: payload.type,
          ranges: payload.ranges,
      }
    })
      .then((response) => response.data)
      .catch((error) =>
        rejectWithValue({
          message: error.message,
          code: error.code,
          data: error.data,
        })
      )
);

export const updateUnassign = createAsyncThunk(
  "companies/updateUnassign",
  async (payload, { rejectWithValue }) =>
    companiesApi
      .updateUnassign({ payload })
      .then((response) => response.data)
      .catch((error) =>
        rejectWithValue({
          message: error.message,
          code: error.code,
          data: error.data,
        })
      )
);

export const setCompanyStatus = createAsyncThunk(
  "companies/setCompanyStatus",
  async (payload, { rejectWithValue }) =>
    companiesApi
      .setCompanyStatus({
        id: payload.id,
        status: payload.status,
        remarks: payload.remarks,
      })
      .then((response) => response.data)
      .catch((error) => rejectWithValue(error))
);

export const getNodeSnRange = createAsyncThunk(
  "companies/getNodeSnRange",
  async (payload, { rejectWithValue }) =>
    companiesApi
      .getNodeSnRange({ id: payload })
      .then((response) => response.data)
      .catch((error) => rejectWithValue(error))
);

export const getSnFormatsByBranch = createAsyncThunk(
  "companies/getSnFormatsByBranch",
  async (payload, { rejectWithValue }) =>
    companiesApi
      .getSnFormatsByBranch({ id: payload })
      .then((response) => response.data)
      .catch((error) => rejectWithValue(error))
);

export const checkSnAssignAvailability = createAsyncThunk(
  "companies/checkSnAssignAvailability",
  async (payload, { rejectWithValue }) =>
    companiesApi
      .checkSnAssignAvailability(payload)
      .then((response) => response.data)
      .catch((error) => rejectWithValue(error))
);

export const getBundleOptions = createAsyncThunk(
  'bundle/getBundleOptions',
  async (_, { rejectWithValue }) => companiesApi
    .getBundleOptions()
    .then((response) => response.data)
    .catch((error) => rejectWithValue(error)),
);

export const getCompanyFeature = createAsyncThunk(
  'companies/getCompanyFeature',
  async (payload, { rejectWithValue }) => companiesApi
    .getCompanyBundle({
        id: payload.id,
    })
    .then((response) => response.data)
    .catch((error) => rejectWithValue(error)),
);

export const reassignNode = createAsyncThunk(
  "companies/reassignNode",
  async (payload, { rejectWithValue }) =>
    companiesApi
      .reassignNode({ payload })
      .then((response) => response.data)
      .catch((error) =>
        rejectWithValue({
          message: error.message,
          code: error.code,
          data: error.data,
        })
      )
);

// Rev 4 save path: a company holds exactly one bundle, so the only thing worth
// sending is the bundle id. There is no per-company fine-tune any more, which is
// why this thunk carries neither `features` nor `properties`.
export const setCompanyBundle = createAsyncThunk(
  'companies/setCompanyBundle',
  async (payload, { rejectWithValue }) => companiesApi
    .setCompanyBundle({
      id: payload.id,
      bundleId: payload.bundleId,
    })
    .then((response) => response.data)
    .catch((error) => rejectWithValue(error)),
);
